export const otp = {
    title:"安全验证",
    label:"邮箱验证码",
    content:"请输入发送至的6位代码",
    button:"确认",
    backToLogin: "返回登录",
    receivedCode: "您还没收到验证码？请稍后申请新验证码 ",
    seconds: "{seconds} 秒",
    receivedCodeYet:"您还没收到验证码？",
    resendCode: "重新发送验证码"
};
